import LazyLoaderErrorBoundary from '@components/Errors/LazyLoaderErrorBoundary';
export default async function Loadable() {
    const { ExternalPlaygroundContainer } = await import('./index');
    return {
        Component: ExternalPlaygroundContainer,
        ErrorBoundary: LazyLoaderErrorBoundary,
    };
}
